import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import PlatformPartners from '../../components/feature/PlatformPartners';
import AIAnswerBlock, { AIAnswer } from '../../components/feature/AIAnswerBlock';
import Process, { ProcessStep } from '../../components/feature/Process';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreas from '../../components/feature/ServiceAreas';
import Testimonials from '../../components/feature/Testimonials';
import FAQ from '../../components/feature/FAQ';
import FinalCTA from '../../components/feature/FinalCTA';
import AboutHero from './components/Hero';
import AboutServicesOverview from './components/ServicesOverview';

const aboutAnswers: AIAnswer[] = [
  {
    q: 'Who is Energy Contractor Services?',
    a: 'Energy Contractor Services (ECS) is a compliance management company based in Oklahoma City, OK. Founded to help energy contractors navigate ISNetworld®, Veriforce, and Avetta requirements, ECS works with contractors across all 50 US states and internationally to achieve and maintain 100% compliance.',
  },
  {
    q: 'How does ECS work with clients?',
    a: "ECS works month-to-month with no long-term contracts. You work directly with a dedicated compliance expert — the same person every time — who manages your accounts, handles documentation, and ensures your compliance never lapses. Cancel at any time with no obligations.",
  },
  {
    q: 'What makes ECS different from other compliance services?',
    a: "Three key differences: personalized service (same expert, not a call center), 100% approval guaranteed (we keep working until you're approved), and flexible month-to-month terms with no contracts. ECS combines deep platform expertise with genuine accountability to client outcomes.",
  },
  {
    q: 'What geographic area does ECS serve?',
    a: 'ECS provides compliance management services for energy contractors nationwide across all 50 US states and internationally, including Canada, the United Kingdom, Australia, Mexico, the Netherlands, New Zealand, and Dubai. Compliance management is conducted remotely — location is never a barrier.',
  },
];

const aboutSteps: ProcessStep[] = [
  {
    number: '01',
    title: 'Initial Consultation',
    description:
      'Reach out by phone or form. We learn about your business, which platforms you need, and your current compliance challenges. No obligation — just clarity.',
  },
  {
    number: '02',
    title: 'Compliance Assessment',
    description:
      'We review your accounts in full — identifying exactly what needs to be done to achieve 100% compliance on ISNetworld, Veriforce, or Avetta.',
  },
  {
    number: '03',
    title: 'Expert Management',
    description:
      'Your dedicated ECS expert handles everything: documentation, updates, safety records, RAVS requirements, and ongoing maintenance. Same person, every interaction.',
  },
  {
    number: '04',
    title: 'Guaranteed Results',
    description:
      "100% approval guaranteed. Once you're compliant, we monitor your accounts monthly to ensure your status never lapses. Month-to-month, cancel anytime.",
  },
];

export default function About() {
  return (
    <main>
      {/* 1. Hero */}
      <Navbar />
      <AboutHero />
      {/* 2. Trust Bar */}
      <TrustBar />
      {/* Platform Showcase */}
      <PlatformPartners />
      {/* 3. Services Overview */}
      <AboutServicesOverview />
      {/* 4. AI Answer Block */}
      <AIAnswerBlock
        answers={aboutAnswers}
        headline="Who Is Energy Contractor Services?"
        subtext="Everything you need to know about ECS — who we are, what we do, and why energy contractors across the US and internationally trust us with their compliance."
      />
      {/* 5. Process */}
      <Process
        steps={aboutSteps}
        headline="How We Work With You"
        subheadline="From first contact to ongoing compliance management — a simple, transparent process with guaranteed results."
      />
      {/* 6. Why Choose Us */}
      <WhyChooseUs />
      {/* 7. Service Areas */}
      <ServiceAreas />
      {/* 8. Testimonials */}
      <Testimonials />
      {/* 9. FAQ */}
      <FAQ />
      {/* 10. Final CTA */}
      <FinalCTA />
      <Footer />
    </main>
  );
}
